import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { getApi, postApi } from "../../services/api/globalApi";
import { Field, Form, Formik } from "formik";
import { motion } from "framer-motion"
import { toast } from "react-toastify";
import ChequeModal from "./ChequeModal";
import * as Yup from 'yup';
import { context } from "../../context/context";


const ProfitChequeFormula = () => {

    const { showLogutModal} = useContext(context)

    const [cheque, setCheque] = useState([])

    const getCurrentLoan = async () => {
        try {
            const data = await getApi({ path: "ProfitLoansFormula/new" })
            console.log(data.data.data)
            setCheque(data.data.data.cheque)

        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getCurrentLoan()
    }, [])

    const addCategory = async (values, { resetForm }) => {

        const test = cheque.filter((item) => item.name == values.name)

        console.log(test)

        if (test.length == 0) {
            const datas = [...cheque, values]
            const body = {
                cheque:
                    [...datas]
            }

            try {
                const response = await postApi({
                    path: 'admin/profitLoansFormula/createOrUpdate',
                    body: body
                });
                toast.success("تغییرات با موفقیت ثبت شد.", {
                    position: "top-right",
                    closeOnClick: true
                });
                resetForm()
                getCurrentLoan()

            } catch (error) {
                console.error(error);
                toast.error(error?.response?.data?.errors.message, {
                    position: "top-right",
                    closeOnClick: true
                });
            error?.response.status == 401 && showLogutModal();
        }
        }
        else {
            toast.warning('نام وارد شده تکراری است.', {
                position: "top-right",
                closeOnClick: true
            });
        }
    }

    const deleteCategory = async (items) => {
        const test = cheque.filter((item) => item.name != items.name)

        const body = {
            cheque:
                [...test]
        }

        try {
            const response = await postApi({
                path: 'admin/profitLoansFormula/createOrUpdate',
                body: body
            });
            toast.success("تغییرات با موفقیت ثبت شد.", {
                position: "top-right",
                closeOnClick: true
            });
            getCurrentLoan()

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.errors.message, {
                position: "top-right",
                closeOnClick: true
            });
            error?.response.status == 401 && showLogutModal();
        }
    }

    const categoryRef = useRef()

    const [currentCategory, setCurrentCategory] = useState(null)

    const showModal = (item) => {
        setCurrentCategory(item)
        categoryRef.current.showModal()
    }

    const validate = Yup.object().shape({
        name: Yup.string()
            .required('وارد کردن نام الزامی است'),
        perMounth: Yup.string()
            .required('وارد کردن سود ماهانه الزامی است'),
        totalProfit: Yup.string()
            .required('وارد کردن سود نهایی الزامی است'),
    });

    return (
        <Fragment>
            <ChequeModal ref={categoryRef} categoryData={cheque} currentCategory={currentCategory} reGetData={getCurrentLoan} />

            <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.5,
                    // ease: [0, 0.71, 0.2, 1.01]
                }} className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

                <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
                    <span className="flex items-center justify-center text-lg text-white">
                        <svg fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="h-6 w-6">
                            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                        </svg>
                    </span>
                    سود چکی اقساط کالا
                </h6>

                <div className="dark:text-white w-11/12 mx-auto mt-4">
                    <div className="flex gap-x-8 mt-6">
                        <div className="w-full flex gap-x-6">
                            <Formik
                                initialValues={{
                                    name: '',
                                    perMounth: '',
                                    totalProfit: '',
                                }}
                                validationSchema={validate}
                                onSubmit={addCategory}

                            >
                                {(formik) => (
                                    <Form className="w-full">
                                        <h4 className="mb-6">دسته بندی جدید را وارد کنید</h4>
                                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                                            <div>
                                                <label for="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نام دسته بندی</label>
                                                <Field autocomplete="off" type="text" name="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    placeholder="نام دسته بندی" />
                                                {formik.errors.name && formik.touched.name ? (
                                                    <p className="text-sm my-4 text-red-500">{formik.errors.name}</p>
                                                ) : null}
                                            </div>
                                            <div>
                                                <label for="perMounth" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">سود ماهانه</label>
                                                <Field autocomplete="off" type="text" name="perMounth" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    placeholder="سود ماهانه" />
                                                {formik.errors.perMounth && formik.touched.perMounth ? (
                                                    <p className="text-sm my-4 text-red-500">{formik.errors.perMounth}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                                            <div>
                                                <label for="totalProfit" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">سود نهایی</label>
                                                <Field autocomplete="off" type="text" name="totalProfit" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    placeholder="سود نهایی" />
                                                {formik.errors.totalProfit && formik.touched.totalProfit ? (
                                                    <p className="text-sm my-4 text-red-500">{formik.errors.totalProfit}</p>
                                                ) : null}
                                            </div>
                                            <div className="flex items-end">
                                                <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                    افزودن
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                    <h3 className="my-4">لیست دسته بندی</h3>
                    <div className="flex w-full">
                        <div className="relative overflow-x-auto shadow-md sm:rounded-lg w-full">
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" className="px-6 py-3 text-center">
                                            نام
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-center">
                                            سود ماهانه
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-center">
                                            سود نهایی
                                        </th>
                                        <th scope="col" className="px-6 py-3 text-center">
                                            <span className="sr-only">عملیات</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cheque.length > 0 ? cheque?.map((item, index) => {
                                        return (
                                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                                <th scope="row" className="px-6 text-center py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                    {item.name || "-"}
                                                </th>
                                                <td className="px-6 text-center py-4">
                                                    {item.perMounth || "-"}
                                                </td>
                                                <td className="px-6 text-center py-4">
                                                    {item.totalProfit || "-"}
                                                </td>
                                                <td className="px-6 text-center py-4 text-right flex">
                                                    <p onClick={() => showModal(item)} className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline">ویرایش</p>
                                                    <p onClick={() => deleteCategory(item)} className="font-medium cursor-pointer text-red-600 dark:text-red-500 hover:underline">حذف</p>
                                                </td>
                                            </tr>
                                        )
                                    }) : null}

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </motion.div>

        </Fragment>
    )
}

export default ProfitChequeFormula